import(/* webpackMode: "eager" */ "/app/src/app/activities/page.tsx");
